import { Text } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import TrackableLink from './TrackableLink';

import { urlBuilder } from '../urlBuilder';

const StyledTrackableLink = styled(TrackableLink)<{
  href: string;
  target: string;
  eventProperties: { name: string; flow: string };
}>`
  display: inline-block;
  margin-bottom: 2rem;
`;

type UserAgreementContentProps = {
  suppressCashReserve?: boolean;
};

const UserAgreementContent: React.FC<UserAgreementContentProps> = ({ suppressCashReserve }) => {
  return (
    <>
      <Text as="p" color="bmtGrey50">
        The terms and conditions in the documents below allow us to provide financial advice to you. They also cover how
        we collect and use your personal information and permit you to access Betterment products in our app that
        require a brokerage account.
      </Text>
      <Text as="p" color="bmtGrey50">
        You confirm that you have reviewed and understand Betterment&apos;s{' '}
        <TrackableLink
          href={urlBuilder.getPrivacyPolicy()}
          target="_blank"
          eventProperties={{ name: 'privacyPolicy', flow: 'UserProfileSetup' }}
        >
          privacy policy{' '}
        </TrackableLink>
        and{' '}
        <TrackableLink
          href={urlBuilder.getCustomerAgreement()}
          target="_blank"
          eventProperties={{ name: 'customerAgreement', flow: 'UserProfileSetup' }}
        >
          customer agreements
        </TrackableLink>
        , which include the Brokerage Agreement, Advisory Agreement, Consent to Electronic Delivery of Documents and
        Written Communications, FINRA&apos;s Margin Disclosure Statement, and other important agreements. You also
        acknowledge that you have received a copy of our{' '}
        <TrackableLink
          href={urlBuilder.getLegalFormCrs()}
          target="_blank"
          eventProperties={{ name: 'formCrsRelationshipSummary', flow: 'UserProfileSetup' }}
        >
          Form CRS relationship summary
        </TrackableLink>
        {' and '}
        <TrackableLink
          href={urlBuilder.getAdv()}
          target="_blank"
          eventProperties={{ name: 'formAdvBrochure', flow: 'UserProfileSetup' }}
        >
          Form ADV brochure
        </TrackableLink>
        . Your advisory agreement and brokerage agreement contain a predispute arbitration clause in the common
        provisions.
      </Text>
      {!suppressCashReserve && (
        <StyledTrackableLink
          href={urlBuilder.getCashReserveTermsAndConditions()}
          target="_blank"
          eventProperties={{ name: 'cashReserveTerms', flow: 'UserProfileSetup' }}
        >
          Cash Reserve terms and conditions
        </StyledTrackableLink>
      )}
    </>
  );
};

export default UserAgreementContent;
